import * as React from "react";
import messages from "box-ui-elements/i18n/en-US";
import { ContentPreview } from "box-ui-elements/es/elements";
const ViewerBoxPreview = ({ className, token, docId, onLoad, }) => {
    if (!docId || !token)
        return null;
    return (React.createElement(ContentPreview, { token: token, fileId: docId, language: "en-US", messages: messages, className: className, onLoad: onLoad }));
};
export default ViewerBoxPreview;
